<template>
  <div class="page">
    <a-card :bordered="false" :bodyStyle="{paddingTop:'10px'}">
      <div class="mb15">
        <Breadcrumb routeName="GoodsList" :cneterName="proName" toName="海报设置" goPathName="商品列表"></Breadcrumb>
      </div>
      <a-row>
        <a-col :span="11">
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                        :label-col="currentFormLayout.labelCol"
                        :wrapper-col="currentFormLayout.wrapperCol">
            <a-form-model-item label="海报模板" prop="posterTemplateId">
              <a-select allowClear
                        style="width: 100%"
                        v-model="ruleForm.posterTemplateId"
                        placeholder="请选择"
              >
                <a-select-option v-for="item in templateList" :key="item.key" :value="item.key">{{ item.value }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="商品名称" prop="posterProName">
              <a-textarea placeholder="请输入" v-model="ruleForm.posterProName" :maxLength="40" auto-size/>
            </a-form-model-item>
            <a-form-model-item label="介绍标语" v-if="ruleForm.posterTemplateId != 13">
              <a-textarea placeholder="请输入" v-model="ruleForm.posterProSlogan" :maxLength="78"
                          :auto-size="{ minRows: 2, maxRows: 5 }"/>
            </a-form-model-item>
            <a-form-model-item label="封面图片" required>
              <div class="main-img">
                <img :src="ruleForm.posterProImg" alt="">
              </div>
              <div class="a-btns">
                <a @click="cropperPosterImg(ruleForm.posterProImg)" :disabled="ruleForm.posterType==2">裁剪</a>
                <a @click="replacePosterImg(ruleForm.posterProImg)" :disabled="ruleForm.posterType==2">更换</a>
              </div>
            </a-form-model-item>
            <a-form-model-item label="促销价" prop="posterPromotionPrice">
              <a-input prefix="￥" placeholder="请输入" suffix="RMB" v-model="ruleForm.posterPromotionPrice"
                       :maxLength="7"/>
            </a-form-model-item>
            <a-form-model-item label="原价" prop="posterOriginalPrice" v-if="ruleForm.posterTemplateId == 13">
              <a-input prefix="￥" placeholder="请输入" suffix="RMB" v-model="ruleForm.posterOriginalPrice"
                       :maxLength="7"/>
            </a-form-model-item>
            <a-form-model-item label="广告语" v-if="ruleForm.posterTemplateId != 13">
              <a-input placeholder="请输入" v-model="ruleForm.posterAdvertisingSlogan" :maxLength="10"/>
            </a-form-model-item>
            <a-form-model-item label="扫码提示" prop="posterScanPrompt">
              <a-input placeholder="请输入" v-model="ruleForm.posterScanPrompt" :maxLength="10"/>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" @click="handleSubmit" :disabled="posterUrl!=''" :loading="submitLoading">
                保存并生成
              </a-button>
              <a-button @click="goBack" style="margin-left:10px;">返回</a-button>
            </a-form-model-item>
          </a-form-model>
        </a-col>
        <a-col :span="7" style="min-width:350px;">
          <div class="upload-a-col">
            <div class="upload-dragger">
              <a-upload-dragger
                name="file"
                class="avatar-uploader"
                :multiple="true"
                :action="actionImageUrl"
                :showUploadList="false"
                @change="handleDraggerChange"
                :before-upload="handleBeforeUploadImage"
              >

                <img class="poster-pic" v-if="ruleForm.posterPosterUrl" :src="ruleForm.posterPosterUrl" alt="">
                <div v-else>
                  <p class="ant-upload-drag-icon">
                    <a-icon type="inbox"/>
                  </p>
                  <p class="ant-upload-text">点击或将文件拖拽到这里上传</p>
                  <p class="ant-upload-hint">支持.jpg .png，尺寸1280px*2636px(宽高)</p>
                  <p class="ant-upload-hint">支持1M以内的图片</p>
                </div>
              </a-upload-dragger>
              <div v-if="posterUrl" class="draggable-code">
                <div class="tags-img" v-if="selectImgCode">
                  <img :src="selectImgCode"/>
                </div>
                <div class="draggable-pic" v-if="qrCodeUrl&&draggableShow">
                  <VueDraggableResizable
                    @dragging="onDrag" @resizing="onResize"
                    :parent="true"
                    :w="width" :h="height" :min-width="45" :min-height="45" :max-height="300" :max-width="300" :x="x"
                    :y="y" :z="999" :lock-aspect-ratio="true">
                    <div class="drag-box">
                      <img :src="qrCodeUrl"/>
                    </div>
                  </VueDraggableResizable>
                </div>
              </div>
            </div>
            <div class="btns">
              <a-tooltip placement="right" v-if="proSource!=0" @click="citeSupplierPoster">
                <template slot="title">引用供应商海报</template>
                <a-icon type="link" :style="{fontSize:'34px',color:'#FAAD14',marginBottom:'10px'}"/>
              </a-tooltip>
              <!-- <a-tooltip placement="right" @click="uploadEvent">
                <template slot="title">上传自有海报</template>
                <a-icon type="cloud-upload" :style="{fontSize:'30px',color:'#FAAD14',marginBottom:'10px'}" />
              </a-tooltip> -->
              <a-tooltip placement="right" @click="saveTemplatePoster">
                <template slot="title">保存并生成</template>
                <a-icon type="save" :style="{fontSize:'34px',color:'#FAAD14' ,marginBottom:'10px'}"/>
              </a-tooltip>
              <a-tooltip placement="right" @click="emptyPoster">
                <template slot="title">清空海报</template>
                <a-icon type="delete" :style="{fontSize:'34px',color:'#FAAD14',marginBottom:'10px'}"/>
              </a-tooltip>
              <a-tooltip placement="right" @click="downloadIamge(ruleForm.posterPosterUrl,'海报')">
                <template slot="title">下载海报</template>
                <a-icon type="download" :style="{fontSize:'34px',color:'#FAAD14'}"/>
              </a-tooltip>
            </div>
          </div>
        </a-col>
        <!--  -->
        <a-col :xxl="6" :xl="4" :lg="4" :sm="10" :md="10" style="min-width:200px;">
          <!--  :tabBarStyle="{'text-align': 'center'}" -->
          <a-tabs default-active-key="1" @change="callback">
            <a-tab-pane key="1" tab="全部组件"></a-tab-pane>
            <!-- <a-tab-pane key="2" tab="近期使用"></a-tab-pane> -->
          </a-tabs>
          <div class="picture-box">
            <div class="picture-img" :class="{'active':item==selectImgCode}" v-for="(item,index) in containerList"
                 :key="index" @click="selectImgEvent(item)">
              <img :src="item" alt="">
            </div>
          </div>
        </a-col>
      </a-row>
      <a-modal title="图片裁剪" :visible="visible" width="700px" :confirm-loading="confirmLoading" @ok="confirmCropImg"
               @cancel="handleCancel">
        <div class="vue-cropper-box">
          <div class="vue-cropper-content">
            <CropperImg :imgUrl="option.img" @getBlobUrl="getBlobUrl"/>
          </div>
        </div>
      </a-modal>
      <!-- 图片更换 -->
      <a-modal title="更换封面图片" :visible="pictureDialog" width="700px" :confirm-loading="confirmLoading"
               @ok="confirmSelectImg" @cancel="handleCancel">
        <div class="upload-btns">
          <a-upload
            name="file"
            :multiple="true"
            :show-upload-list="false"
            :action="actionImageUrl"
            @change="handleChange"
            :before-upload="beforeUploadFile"
          >
            <a-button>
              <a-icon type="upload"/>
              上传图片
            </a-button>
          </a-upload>
        </div>
        <ul class="img-list clearfix" v-if="ruleForm.proImgList.length>0">
          <li v-for="(item,index) in ruleForm.proImgList" :key="index" @click="getSelectImg(item,index)">
            <img :src="item" alt="">
            <div v-if="activeIndex == index" class="bg-img"><img src="../../../public/cancel_img.png" alt=""></div>
          </li>
        </ul>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import CropperImg from '@/customComponents/CropperImg/CropperImg'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

export default {
  name: 'PosterSet',
  components: {
    Breadcrumb,
    CropperImg,
    VueDraggableResizable
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      draggableFlag: true,
      isPaster: true,//是否使用贴纸
      isQuoteFlag: false,
      draggableShow: false,
      proId: this.$route.query.proId,
      catalogId: this.$route.query.catalogId,
      proSource: this.$route.query.proSource,
      proName: '',
      templateList: [],
      containerList: [],
      actionImageUrl: this.getAppConfig().baseUrl + 'base/upload',
      ruleForm: {
        posterProImg: '',
        posterType: 1,//1 为系统海报，2为上传的自由海报
        posterAdvertisingSlogan: '',//广告语
        proImgList: [],// 商品图片List集合
        posterProName: '',//商品名称
        posterProSlogan: '',//介绍标语
        posterPromotionPrice: 0,//促销价
        posterOriginalPrice: 0,//原价
        posterScanPrompt: '',//扫码提示
        posterPosterUrl: '',
        proCatalogId: this.$route.query.catalogId,
        advanceId: 0,
        posterProId: this.$route.query.proId,
        isPreview: false//预览效果传 true, 保存传 false
      },
      posterUrl: '',
      qrCodeUrl: '',
      x: 120,
      y: 310,
      width: 65,
      height: 65,
      submitLoading: false,
      rules: {
        posterTemplateId: [
          { required: true, message: '请选择海报模板', trigger: 'change' }
        ],
        posterProName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        posterPromotionPrice: [
          { required: true, message: '请输入促销价', trigger: 'blur' },
          { pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/, message: '请输入正确的促销价' }
        ],
        posterOriginalPrice: [
          { required: true, message: '请输入原价', trigger: 'blur' },
          { pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/, message: '请输入正确的原价' }
        ]
      },
      currentFormLayout: {
        labelCol: {
          xxl: { span: 3 },
          xl: { span: 4 },
          lg: { span: 5 },
          sm: { span: 5 },
          md: { span: 7 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 20 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 19 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 18 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 17 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 3 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 4 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 5 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 5 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 7 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      submitFormData: '',
      //裁剪组件的基础配置option
      option: {
        img: ''//裁剪图片的地址
      },
      cropperImgUrl: '',
      activeIndex: -1,
      confirmPic: '',
      pictureDialog: false,
      selectImgCode: ''
    }
  },
  mounted() {
  },
  activated() {
    this.getNewData()
  },
  methods: {
    uploadEvent() {
      this.$message.error('点击图片即可上传海报')
    },
    selectImgEvent(img) {
      if (!this.posterUrl) {
        this.$message.error('请先上传海报图片')
        return
      }
      if (!this.isPaster) {
        this.$message.error('引用供应商海报不允许使用贴纸')
        return
      }
      this.selectImgCode = img
      this.draggableShow = false
    },
    //更换图片
    replacePosterImg(posterProImg) {
      this.pictureDialog = true
      if (this.ruleForm.proImgList.indexOf(posterProImg) > -1) {
        this.activeIndex = this.ruleForm.proImgList.indexOf(posterProImg)
      }
    },
    //获取选中的图片
    getSelectImg(item, index) {
      this.activeIndex = index
      this.confirmPic = ''//先清空一波
      this.confirmPic = item
    },
    //确定选择的图片
    confirmSelectImg() {
      if (this.confirmPic) {
        this.ruleForm.posterProImg = this.confirmPic
      }
      this.getLogUtils().logWithTag('this.ruleForm.posterProImg', this.ruleForm.posterProImg)
      this.pictureDialog = false
    },
    handleCancel(e) {
      this.visible = false
      this.pictureDialog = false
    },
    //裁剪弹窗
    cropperPosterImg(posterProImg) {
      this.visible = true
      this.option.img = this.ruleForm.posterProImg
    },
    //确定好裁剪的图片
    confirmCropImg() {
      this.confirmLoading = true
      this.getHttpServices().getBaseService().post('base/uploadBase64', {
        img: this.cropperImgUrl
      }).then(res => {
        this.ruleForm.posterProImg = res
        this.visible = false
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //获取截图后的信息
    getBlobUrl(data) {
      // this.getLogUtils().logWithTag("getBlobUrl:",data)
      this.cropperImgUrl = data
    },
    //调整缩放
    onResize: function(x, y, width, height) {
      this.x = x
      this.y = y
      this.width = width
      this.height = height
      // this.getLogUtils().logWithTag("调整缩放X:",x,"调整缩放y:",y,width,height)
    },
    //移动位置
    onDrag: function(x, y) {
      this.x = x
      this.y = y
      // this.getLogUtils().logWithTag("移动位置x:",x,"移动位置y:",y)
    },
    callback(key) {
      // this.getLogUtils().logWithTag(key);
      this.getLogUtils().logWithTag('callback', key)
    },
    getNewData() {
      this.proId = this.$route.query.proId
      this.catalogId = this.$route.query.catalogId
      this.proSource = this.$route.query.proSource
      this.proName = ''
      this.isQuoteFlag = false
      this.selectImgCode = ''
      this.cropperImgUrl = ''
      this.confirmLoading = false
      this.posterUrl = ''
      this.qrCodeUrl = ''
      this.draggableShow = false
      this.isPaster = true
      this.x = 120
      this.y = 310
      this.width = 65
      this.height = 65
      this.option = {
        img: ''//裁剪图片的地址
      }
      this.activeIndex = -1
      this.confirmPic = ''
      this.pictureDialog = false
      this.ruleForm = {
        posterProImg: '',
        posterType: 1,//1 为系统海报，2为上传的自由海报
        posterAdvertisingSlogan: '',//广告语
        proImgList: [],// 商品图片List集合
        posterProName: '',//商品名称
        posterProSlogan: '',//介绍标语
        posterPromotionPrice: 0,//促销价
        posterOriginalPrice: 0,//原价
        posterScanPrompt: '',//扫码提示
        posterPosterUrl: '',
        proCatalogId: this.$route.query.catalogId,
        advanceId: 0,
        posterProId: this.$route.query.proId,
        isPreview: false//预览效果传 true, 保存传 false
      }
      this.getPosterTemplateList()
      this.getPutPosterInfo()
      this.getPosterContainers()
    },
    // 获取供应商海报
    citeSupplierPoster() {
      if (!this.isQuoteFlag) {
        this.x = 120
        this.y = 310
        this.width = 65
        this.height = 65
      }
      this.getHttpServices().getProService().get('public/getProSupplierPoster?proId=' + this.proId).then(res => {
        if (res && res.posterTemplate) {
          this.posterUrl = res.posterTemplate
          this.selectImgCode = ''
          this.draggableShow = true
          this.isPaster = false
          this.ruleForm.posterType = 2
          this.isQuoteFlag = true
          this.ruleForm.posterPosterUrl = res.posterTemplate
          this.x = res.qrCodeX / 4
          this.y = res.qrCodeY / 4
          this.width = res.qrCodeWidth / 4
          this.height = res.qrCodeHeight / 4
          // this.getLogUtils().logWithTag("调整缩放X:",this.x,"调整缩放y:",this.y,this.width,this.height)
          this.getCodeImage()
          this.$message.success('引用供应商海报成功')
        } else {
          this.$message.error('供应商未上传自有海报')
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取海报贴纸
    getPosterContainers() {
      this.getHttpServices().getProService().get('public/getPosterContainers').then(res => {
        this.containerList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取海报模板
    getPosterTemplateList() {
      this.getHttpServices().getServerApiService().post('poster/getPosterTemplateList', {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        posterProUse: this.catalogId
      }).then(res => {
        this.templateList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getPutPosterInfo() {
      this.getHttpServices().getProService().post('public/getPosterTemplateByProId', {
        posterProId: this.proId,
        proCatalogId: this.catalogId
      }).then(res => {
        this.ruleForm = res
        this.ruleForm.posterTemplateId = this.ruleForm.posterTemplateId ? this.ruleForm.posterTemplateId : undefined
        this.proName = res.posterProName && res.posterProName.length > 20 ? res.posterProName.substr(0, 19) + '...' : res.posterProName
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getCodeImage() {
      this.getHttpServices().getProService().get('public/getProQRCode?proId=' + this.proId + '&advanceId=0', {}).then(res => {
        this.qrCodeUrl = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleSubmit() {
      console.error('this.ruleForm', this.ruleForm)
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.getLogUtils().logWithTag('submitFormData', this.submitFormData)
      this.getHttpServices().getProService().post('public/putPosterTemplate', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('保存成功')
        this.getPutPosterInfo()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    goBack() {
      this.$router.go(-1)
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(info.fileList)
        // Get this url from response in real world.
        this.ruleForm.proImgList.push(url)
      }
    },
    handleDraggerChange(info) {
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(info.fileList)
        // Get this url from response in real world.
        this.posterUrl = url
        this.ruleForm.posterPosterUrl = url
        this.draggableShow = true
        this.isPaster = true
        this.isQuoteFlag = false
        this.getCodeImage()//获取二维码
        this.getLogUtils().logWithTag('handleDraggerChange', url)
      }
    },
    getLatestUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        const lastIndex = fileList.length - 1
        if (fileList[lastIndex] && fileList[lastIndex].response) {
          return fileList[lastIndex].response.data
        }
      }
      return ''
    },
    handleBeforeUploadImage(file) {
      this.getLogUtils().logWithTag('handleBeforeUploadImage', file)
      // 限制图片 格式、size、分辨率
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isJPEG || isPNG)) {
        this.$message.error('上传图片的格式不正确，不是JPG、JPEG、GIF、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 3
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于3M!')
        return false
      }
      let that = this
      return new Promise(function(resolve, reject) {
        let filereader = new FileReader()
        let width = 1280
        let height = 2636
        filereader.onload = e => {
          let src = e.target.result
          const image = new Image()
          image.onload = function() {
            let valid = image.width == width && image.height == height
            if (!valid) {
              that.$message.error('上传的图片尺寸必须是1280px*2636px(宽高)')
              reject()
            } else {
              resolve()
            }
          }
          image.onerror = reject
          image.src = src
        }
        filereader.readAsDataURL(file)
      })
      return true
    },
    beforeUploadFile(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 3
      if (!isJPG && !isPNG) {
        this.$message.error('请选择正确的图片格式上传!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 3MB!')
        return false
      }
      return true
    },
    // 清空海报
    emptyPoster() {
      this.ruleForm.posterPosterUrl = ''
      this.posterUrl = ''
      this.selectImgCode = ''
      this.draggableShow = false
      this.isPaster = true
      this.isQuoteFlag = false
    },
    //下载海报方法二
    downloadIamge(imgsrc, name) {//下载图片地址和图片名
      if (imgsrc) {
        let image = new Image()
        // 解决跨域 Canvas 污染问题
        image.setAttribute('crossOrigin', 'anonymous')
        image.onload = function() {
          let canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          let context = canvas.getContext('2d')
          context.drawImage(image, 0, 0, image.width, image.height)
          let url = canvas.toDataURL('image/jpeg') //得到图片的base64编码数据
          let a = document.createElement('a') // 生成一个a元素
          let event = new MouseEvent('click') // 创建一个单击事件
          a.download = name || 'photo' // 设置图片名称
          a.href = url // 将生成的URL设置为a.href属性
          a.dispatchEvent(event) // 触发a的单击事件
        }
        image.src = imgsrc
      } else {
        this.$message.error('请先点击保存海报后再下载')
      }
    },
    //自有海报保存接口
    saveTemplatePoster() {
      if (!this.posterUrl) {
        this.$message.error('请先上传自有海报')
        return
      }
      this.getHttpServices().getProService().post('public/templatePoster', {
        posterProId: this.proId,
        posterQrCodeHeight: this.height * 4,//二维码高度
        posterQrCodeWidth: this.width * 4,//二维码宽度
        posterQrCodeX: this.x * 4,// 二维码X轴位置 ,
        posterQrCodeY: this.y * 4,//二维码Y轴位置 ,
        posterTemplateUrl: this.posterUrl,  //模板Ur
        qrCodeUrl: this.qrCodeUrl,//二维码Url ,
        posterStickerUrl: this.selectImgCode
      }).then(res => {
        this.ruleForm.posterPosterUrl = res
        this.posterUrl = ''
        this.selectImgCode = ''
        this.isPaster = true
        this.isQuoteFlag = false
        this.$message.success('海报保存成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style>

</style>
<style scoped lang="less">
.upload-a-col {
  display: flex;
}

.bread-crumb {
  padding-left: 0 !important;
}

.mb15 {
  margin-bottom: 15px;
}

.upload-box {
  .avatar-uploader > .ant-upload {
    width: 100px;
    height: 100px;
  }
}

.img-avatar {
  width: 100px;
  height: 100px;
}

.inner-size() {
  width: 322px;
  height: 661px;
}

.ant-upload-drag-icon {
  margin-top: 20px;
}

.upload-dragger {
  margin: 0 auto;
  position: relative;
  .inner-size();

  .tags-img {
    width: 320px;
    height: 75px;
    position: absolute;
    left: 0;
    bottom: 0;

    img {
      width: 320px;
      height: 75px;
    }
  }

  .ant-upload.ant-upload-select-picture-card > .ant-upload {
    padding: 0;
  }

  .ant-upload.ant-upload-select-picture-card {
    .inner-size();
    padding: 0;
  }

  .ant-upload {
    .inner-size();

    .ant-upload-select-picture-card {
      .inner-size();
      padding: 0;
    }

    .picture-card {
      .inner-size();
    }
  }

  .ant-upload.ant-upload-drag .ant-upload-drag-container {
    vertical-align: top !important;
  }

  .picture-card .ant-upload-list-item {
    padding: 0;
  }
}

.btns {
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.poster-pic {
  width: 320px;
  height: 659px;
}

.draggable-code {
  width: 320px;
  height: 659px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
}

.draggable-pic {
  width: 320px;
  height: 659px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
}

.picture-box {
  .picture-img {
    width: 100%;
    height: auto;
    border-radius: 4px;
    border: 1px solid #E9E9E9;
    padding: 4px;
    cursor: pointer;
    margin-bottom: 10px;
    overflow: hidden;

    &.active {
      border: 1px solid red;
    }

    img {
      width: 100%;
      height: auto;
      border-radius: 4px;
    }
  }
}

.drag-box {
  position: relative;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
  }
}

.main-img {
  width: 150px;
  height: 120px;
  overflow: hidden;

  img {
    width: auto;
    height: 100%;
  }
}

.a-btns {
  a {
    font-size: 16px;
  }

  a + a {
    margin-left: 10px;
  }
}

.vue-cropper-content {
  height: 450px;
}

ul, li {
  list-style: none;
  padding: 0;
}

.img-list {
  li {
    width: 98px;
    height: 80px;
    float: left;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      position: relative;
      z-index: 1;
    }

    .bg-img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      text-align: center;
      line-height: 80px;
      z-index: 8888;
      font-size: 20px !important;
      font-weight: bold;
      color: red;
      background-color: rgba(0, 0, 0, 0.4);

      img {
        width: 35px;
        height: 35px;
      }
    }
  }

}

.upload-btns {
  margin-bottom: 10px;
}
</style>
<style lang="less">
.upload-dragger {
  .ant-upload.ant-upload-drag .ant-upload-drag-container {
    vertical-align: top !important;
  }

  .ant-upload.ant-upload-drag .ant-upload {
    padding: 0;
  }
}
</style>
